import { render } from "./CartDiscount.vue?vue&type=template&id=42dc464d&scoped=true"
import script from "./CartDiscount.vue?vue&type=script&lang=js"
export * from "./CartDiscount.vue?vue&type=script&lang=js"

import "./CartDiscount.vue?vue&type=style&index=0&id=42dc464d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dc464d"]])

export default __exports__